const GRAPH_API_BASE = "https://graph.microsoft.com/v1.0";

export async function fetchMemberOf(
    token: string,
    transitive = true // default includes nested/mail-enabled groups
): Promise<string[]> {
    const endpoint = transitive
        ? `${GRAPH_API_BASE}/me/transitiveMemberOf`
        : `${GRAPH_API_BASE}/me/memberOf`;

    const response = await fetch(endpoint, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(
            `Graph API call failed (${response.status} ${response.statusText}): ${errorBody}`
        );
    }

    const data = await response.json();

    // Safely map to displayName only
    return (data.value ?? [])
        .map((g: any) => g.displayName)
        .filter((name: string | undefined): name is string => Boolean(name));
}
